import BenzAMRRecorder from 'benz-amr-recorder'

/*
 * @Descripttion: https://www.npmjs.com/package/benz-amr-recorder
 * @version: 1.0.0
 * @LastEditTime: 2022-06-21 15:50:15
 */
export default class AmrPlayer {
  constructor(options = {}) {
    this.options = options

    this.amr = new BenzAMRRecorder()

    const { el } = options

    this.el = el

    this.handleBars = {}

    this.init()
    this.bindEventForEl()
  }

  init() {
    try {
      const src = this.options?.src
      if (!src) throw new Error('请传入语音 src 属性')
      this.amr.initWithUrl(src).then(() => {
        this.getIsInit()
        this.getDuration()
      })
    } catch (error) {
      console.warn(error)
    }
  }

  // 订阅
  subscribe(eventName, handle) {
    try {
      if (!this.handleBars.hasOwnProperty(eventName)) {
        this.handleBars[eventName] = []
      }
      if (typeof handle === 'function') {
        this.handleBars[eventName].push(handle)
      } else {
        throw new Error(`你需要给${eventName}事件添加回调方法`)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  // 发布
  publish(eventName, ...arg) {
    try {
      if (this.handleBars.hasOwnProperty(eventName)) {
        this.handleBars[eventName].map((item) => {
          item.apply(null, arg)
        })
      } else {
        throw new Error(`${eventName}事件未被注册`)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  // 移除订阅
  unSubscribe(eventName, handle) {
    try {
      if (this.handleBars.hasOwnProperty(eventName)) {
        this.handleBars[eventName].map((item, index) => {
          if (item === handle) {
            console.log(item)
            this.handleBars[eventName].splice(index, 1)
          }
        })
      }
    } catch (error) {
      console.warn(error)
    }
  }

  bindEvent() {
    const { bindEvent = {} } = this.options
    Object.keys(bindEvent).forEach((key) => {
      const fn = bindEvent[key]
      this.subscribe(key, fn)
    })
  }

  bindEventForEl() {
    const { el } = this
    if (!el) {
      console.log('没有传入绑定元素el， 请自行绑定事件并初始化amr。')
    }
    el.onclick = () => {
      this.playOrPauseOrResume()
      this.onEnd()
    }
    this.bindEvent()
  }

  getIsInit() {
    if (!this.amr) throw new Error('amr 没有实例')
    const isInit = this.amr.isInit()
    this.publish('getIsInit', { isInit })
    return isInit
  }

  getDuration() {
    if (!this.amr) throw new Error('amr 没有实例')
    let duration = this.amr.getDuration()
    const isCeil = this.options?.isCeil
    if (isCeil) {
      duration = Math.ceil(duration)
    }
    this.publish('getDuration', { duration })
    return duration
  }

  /**
   * 播放（无视暂停状态）
   * @param {number?} startTime 可指定播放开始位置（秒，浮点数，可选）
   */
  play() {
    console.log('play')
    if (this.amr) {
      this.amr.play()
    }
    this.emitData('play')
  }

  /**
   * 暂停
   * @since 1.1.0
   */
  pause() {
    this.amr && this.amr.pause()
    this.emitData('pause')
  }

  /**
   * 停止
   */
  stop() {
    this.amr && this.amr.stop()
    this.emitData('stop')
  }

  emitData(eventName) {
    const { amr } = this
    const isPaused = amr.isPaused()
    const isPlaying = amr.isPlaying()
    this.publish(eventName, { isPaused, isPlaying, eventName })
  }

  /**
   * 从暂停状态中继续播放
   * @since 1.1.0
   */
  resume() {
    this.amr && this.amr.resume()
    this.publish('resume')
  }

  /**
   * 整合 play() 和 resume()，若在暂停状态则继续，否则从头播放
   * @since 1.1.0
   */
  playOrResume() {
    this.amr && this.amr.playOrResume()
    this.publish('playOrResume')
  }

  /**
   * 整合 resume() 和 pause()，切换暂停状态
   * @since 1.1.0
   */
  pauseOrResume() {
    this.amr && this.amr.pauseOrResume()
    this.publish('pauseOrResume')
  }

  /**
   * 整合 play() 和 resume() 和 pause()
   * @since 1.1.0
   */
  playOrPauseOrResume() {
    console.log('amr', 'playOrPauseOrResume')
    const { amr } = this
    amr && amr.playOrPauseOrResume()
    this.emitData('playOrPauseOrResume')
  }

  /**
   * 跳转到音频指定位置，不改变播放状态（若停止状态则等同于 `play(time)`）
   * @since 1.1.0
   * @param {Number} time 指定位置（秒，浮点数）
   */
  setPosition(time) {
    this.amr && this.amr.setPosition(time)
    this.publish('setPosition')
  }

  /**
   * 获取当前播放位置（秒）
   * @since 1.1.0
   * @return {Number} 位置，秒，浮点数
   */
  getCurrentPosition() {
    if (!this.amr) throw new Error('amr 没有实例')
    const currentPosition = this.amr.getCurrentPosition()
    this.publish('getCurrentPosition', currentPosition)
    return currentPosition
  }

  /**
   * 是否正在播放
   * @return {boolean}
   */
  isPlaying() {
    if (!this.amr) throw new Error('amr 没有实例')
    const isPlaying = this.amr.isPlaying()
    this.publish('isPlaying', isPlaying)
    return isPlaying
  }

  /**
   * 是否暂停中
   * @since 1.1.0
   * @return {boolean}
   */
  isPaused(needPush = true) {
    if (!this.amr) throw new Error('amr 没有实例')
    const isPaused = this.amr.isPaused()
    this.publish('isPaused', isPaused)
    return isPaused
  }

  onPlay(cb) {
    const defaultFn = () => {
      console.log('开始播放')
      this.publish('onPlay')
    }
    const startFn = cb || defaultFn
    this.amr && this.amr.onPlay(startFn)
  }

  onEnd(cb) {
    const defaultFn = () => {
      console.log('播放完毕')
      this.emitData('onEnd')
    }
    const endFn = cb || defaultFn
    this.amr && this.amr.onEnded(endFn)
  }
}
